export var VehicleConfigurationAttributesType;
(function (VehicleConfigurationAttributesType) {
    VehicleConfigurationAttributesType["PIN_ATTRIBUTES"] = "pinAttributes";
    VehicleConfigurationAttributesType["NADA_ATTRIBUTES"] = "nadaAttributes";
    VehicleConfigurationAttributesType["REDBOOK_ATTRIBUTES"] = "redbookAttributes";
})(VehicleConfigurationAttributesType || (VehicleConfigurationAttributesType = {}));
//# sourceMappingURL=VehicleConfigurationAttributesType.js.map